<script setup lang="ts">
import { ElButton } from "element-plus";
const goToFindOutMore = () => {
  window.open("https://www.swipedon.com/sign-in-solutions");
};
</script>
<template>
  <div class="banner">
    <p>{{ $t("supgrade.upgradeReady") }}</p>
    <div>
      <el-button
        class="cta-btn"
        bordered
        type="primary"
        size="default"
        @click="$router.push('/upgrade/schedule')"
        >{{ $t("supgrade.scheduleUpgradeButton") }}</el-button
      >
      <el-button
        class="cta-btn"
        bordered
        type="primary"
        size="default"
        @click="goToFindOutMore"
        >{{ $t("supgrade.findOutMoreButton") }}</el-button
      >
    </div>
  </div>
</template>
<style lang="scss" scoped>
.banner {
  background: #1bbae1;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  min-height: 50px;
  padding: 0.5rem;
  gap: 0.5rem;
  & p {
    margin-right: 1rem;
    font-weight: 600;
    color: white;
    font-size: 1rem;
  }
  & .cta-btn {
    border-color: var(--so-text-color-trial-banner);
  }
}
</style>
